import { Navigate } from 'react-router-dom';

/** Ruta legacy — redirige a Administración */
export default function InformeIvaOperacionesPage() {
  return <Navigate to="/informes-iva/administracion" replace />;
}
